import { requestApi } from '../api';
import { BaseRepository } from './base';

const options = { skipAuthRedirect: true };

class Repository extends BaseRepository {
  getHistory = (address, page = 1, limit = 20) =>
    requestApi('get', `${this.path}/history`, { address, page, limit }, false, false, options);

  getLeaderboard = (address) => requestApi('get', `${this.path}/leaderboard`, { address }, false, false, options);
}

export const PointsRepository = new Repository('/points');
